var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-footer",
    {
      staticClass: "employee-nav",
      attrs: { app: "", padless: "", height: "72" },
    },
    [
      _c(
        "router-link",
        { staticClass: "employee-nav__item", attrs: { to: _vm.news_path } },
        [
          _c(
            "span",
            { staticClass: "employee-nav__icon" },
            [
              _c(
                "v-badge",
                {
                  attrs: {
                    value: _vm.$store.state.news_unread > 0,
                    content: _vm.$store.state.news_unread,
                    color: "orange",
                    overlap: "",
                  },
                },
                [_c("v-icon", [_vm._v("mdi-bullhorn-outline")])],
                1
              ),
            ],
            1
          ),
          _c("span", [_vm._v("Novedades")]),
        ]
      ),
      _c(
        "router-link",
        {
          staticClass: "employee-nav__item",
          attrs: { to: _vm.my_payslips_path },
        },
        [
          _c(
            "span",
            { staticClass: "employee-nav__icon" },
            [
              _c(
                "v-badge",
                {
                  attrs: {
                    value: _vm.$store.state.my_payslips_pending > 0,
                    content: _vm.$store.state.my_payslips_pending,
                    color: "orange",
                    overlap: "",
                  },
                },
                [_c("v-icon", [_vm._v("mdi-file-document-outline")])],
                1
              ),
            ],
            1
          ),
          _c("span", [_vm._v("Mis recibos")]),
        ]
      ),
      _c(
        "router-link",
        {
          staticClass: "employee-nav__item",
          attrs: { to: _vm.my_account_path },
        },
        [
          _c(
            "span",
            { staticClass: "employee-nav__icon" },
            [_c("v-icon", [_vm._v("mdi-account-circle-outline")])],
            1
          ),
          _c("span", [_vm._v("Mi cuenta")]),
        ]
      ),
      _c(
        "v-bottom-sheet",
        {
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "employee-nav__item",
                          class: { "employee-nav__item--open": _vm.more_sheet },
                          attrs: { type: "button" },
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "span",
                        { staticClass: "employee-nav__icon" },
                        [_c("v-icon", [_vm._v("mdi-dots-horizontal")])],
                        1
                      ),
                      _c("span", [_vm._v("Más")]),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.more_sheet,
            callback: function ($$v) {
              _vm.more_sheet = $$v
            },
            expression: "more_sheet",
          },
        },
        [
          _c(
            "v-sheet",
            { staticClass: "employee-sheet" },
            [
              _c("div", { staticClass: "employee-sheet__handle" }),
              _c("div", { staticClass: "employee-sheet__title" }, [
                _vm._v("Más opciones"),
              ]),
              _c(
                "v-list",
                _vm._l(_vm.more_items, function (item) {
                  return _c(
                    "v-list-item",
                    { key: item.title, attrs: { disabled: "" } },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-4" },
                        [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [_vm._v(_vm._s(item.title))]),
                          _c("v-list-item-subtitle", [_vm._v("Próximamente")]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }